import './_collection-hatbox-nav.scss';
import component from './collection-hatbox-nav';

export default component;
